module.exports = __webpack_public_path__ + "static/media/ginza-crossing.eda0c4b8.jpg";